export default "__VITE_PUBLIC_ASSET__17110c26__"